var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalkModeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#4B33A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14C23.1 14 24 13.1 24 12C24 10.9 23.1 10 22 10C20.9 10 20 10.9 20 12C20 13.1 20.9 14 22 14ZM18.3 17.4L15.7469 30.2567C15.6191 30.9002 16.1114 31.5 16.7675 31.5C17.2542 31.5 17.6759 31.1627 17.7827 30.6878L19.4 23.5L21.5 25.5V30.5C21.5 31.0523 21.9477 31.5 22.5 31.5C23.0523 31.5 23.5 31.0523 23.5 30.5V24L21.4 22L22 19C23.1005 20.2698 24.7026 21.1813 26.5031 21.4312C27.0501 21.5071 27.5 21.0523 27.5 20.5C27.5 19.9477 27.0481 19.5103 26.5057 19.4062C25.0497 19.1269 23.8559 18.2479 23.2 17.1L22.2 15.5C21.8 14.9 21.2 14.5 20.5 14.5C20.2 14.5 20 14.6 19.7 14.6L14.5 16.8V20.5C14.5 21.0523 14.9477 21.5 15.5 21.5C16.0523 21.5 16.5 21.0523 16.5 20.5V18.1L18.3 17.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkModeSelected);
export default __webpack_public_path__ + "static/media/walkModeSelected.0815a63fa1bc32a6d1ed767056b5e6e6.svg";
export { ForwardRef as ReactComponent };